"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const popover_button_1 = __importDefault(require("./popover.button"));
const popover_menu_1 = __importDefault(require("./popover.menu"));
class Popover extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            expanded: false
        };
        this.toggle = () => {
            this.setState({
                expanded: !this.state.expanded
            });
        };
        this.collapse = () => {
            this.setState({
                expanded: false
            });
        };
        this.render = () => {
            const { children, smallButton, avatarButton, avatarSize, avatarSrc, loading } = this.props;
            const { expanded } = this.state;
            const buttonProps = {
                onClick: this.toggle,
                expanded,
                small: smallButton,
                avatarButton,
                avatarSize,
                avatarSrc,
                loading,
                buttonRef: el => {
                    this.button = el;
                }
            };
            return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx(popover_button_1.default, Object.assign({}, buttonProps), void 0),
                    !loading && expanded && (jsx_runtime_1.jsx(popover_menu_1.default, Object.assign({ handleCollapse: this.collapse, button: this.button }, { children: children }), void 0))] }, void 0));
        };
    }
}
Popover.propTypes = {
    children: prop_types_1.default.node.isRequired,
    smallButton: prop_types_1.default.bool,
    avatarButton: prop_types_1.default.bool,
    avatarSize: prop_types_1.default.number,
    avatarSrc: prop_types_1.default.string,
    loading: prop_types_1.default.bool
};
Popover.defaultProps = {
    smallButton: false,
    avatarButton: false,
    avatarSize: null,
    avatarSrc: '',
    loading: false
};
exports.default = Popover;
//# sourceMappingURL=popover.js.map